module.exports = __webpack_public_path__ + "media/images/flags/4x3/mar-fa3e99609339199a6545ed315c3c011e.svg";